// Libs
import { FormControl, FormErrorMessage, FormHelperText, FormLabel, Textarea as ChakraTextarea } from "@chakra-ui/react"

export default function Textarea({ label, error, helper, leftAddon, leftElement, rightAddon, rightElement, type = 'text', ...props }){
    return(
    <FormControl isInvalid={!!error}>
        { label && <FormLabel fontSize="sm" children={label} /> }
        <ChakraTextarea ref={props?.inputRef} {...props} />
        { !!error && <FormErrorMessage children={error} /> }
        { (!error && !!helper) && <FormHelperText fontSize="xs" children={helper} />}
    </FormControl>
    )
}